import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { RelatedContactFormResult } from "./AddRelatedContactForm";

export const convertContactToRelatedContact = (
  contact: Partial<TellescopeModelFromName<"endusers">>,
  relatedEnduserId: string
): RelatedContactFormResult | undefined => {
  const relationship = contact.relationships?.find(({ id }) => id === relatedEnduserId)?.type;
  if (!relationship) return undefined;
  return {
    fname: contact.fname ?? "",
    lname: contact.lname,
    relationship,
    dateOfBirth: contact.dateOfBirth ? new Date(contact.dateOfBirth) : undefined,
    email: contact.email ?? "",
    phoneNumber: contact.phone,
  };
};
